import decreaseImg from './decrease.svg'
import increaseImg from './increase.svg'

export const images = { decreaseImg, increaseImg }
